export {TagSelectModule} from './tag-select/tag-select.module';
